module.exports = __webpack_public_path__ + "img/IMG_1627_FoamcoreMatted_MockedUp.24970789.jpg";